import React from 'react';
import DatePicker from 'react-datepicker';
import { AsteriskRed } from '../../../../components/tools/Others';
import DatePickerForForm from '../../../others/components/common/DatePickerForForm';

export default class ValidationInstallationFields  extends React.Component {

    showMeterReadingDate = () => {
        //hide this field for all forms: 118548
        return false;
        /*
        const form = this.props.validationForm;
        if(form.val('meterReadingDate')) return true;
        if(form.val('newMeterEquipment') == '1' || form.val('newMeterEquipment') == '3') {
            return true;
        }
        return false;
        */
    }

    showMeterReading = () => {
        //hide this field for all forms: 118548
        return false;
        /*
        const form = this.props.validationForm;
        if(form.val('meterReading')) return true;
        if(form.val('newMeterEquipment') == '1' || form.val('newMeterEquipment') == '3') {
            return true;
        }
        return false;
        */
    }

    constructor(props) {
        super(props);
        this.state = {};
    }
    
    render = () => {
        const form = this.props.validationForm;
        return <>
            {form.renderTextBoxRow('installerDQPName',<>
                Installer DQP Name
            </>,{labelWidth:4,fieldWidth:3,rowClasses:'mb-3'})}

            {form.renderTextBoxRow('installerDQPCMI',<>
                Installer DQP CMI Number
            </>,{labelWidth:4,fieldWidth:3,rowClasses:'mb-3'})}

            {this.showMeterReadingDate() && <div className={`row mb-3`}>
                <div className={`col-md-4 py-2`}>Meter Installation Date <AsteriskRed/></div>
                <div className={`col-md-3`}>
                    <DatePickerForForm form={form} fieldName="meterReadingDate" />
                </div>
            </div>}
            {this.showMeterReading() && form.renderTextBoxRow('meterReading',<>
                Meter Reading At The Time Of Installation <AsteriskRed/>
                <br /><span className='fs-80'>(as displayed on meter either when meter installed (meter only) or when LID connected)</span>
            </>,{labelWidth:4,fieldWidth:3})}

            {form.vals().newMeterEquipment == '3' && 
                form.renderTextBoxRow('replacedMeterFinalReading',<>
                    Final Meter Reading of Failed/Replaced meter <AsteriskRed/>
                    <br/><span className='fs-80'>(as displayed on meter either when LID is connected or when there is only meter installed)</span>
                </>,{labelWidth:4,fieldWidth:3})
            }

            <div className={`row mb-3`}>
                <div className={`col-md-4 py-2`}>
                    Site Commissioning Date <AsteriskRed/>
                    <br/><span className='fs-80'>(as displayed on meter either when LID is connected or when there is only meter installed)</span>
                </div>
                <div className={`col-md-3`}>
                    <DatePickerForForm form={form} fieldName="lidInstallationDate" />
                </div>
            </div>
            {form.renderTextBoxRow('meterReadingAtLidInstallation',<>
                Meter Reading On Commissioning Date <AsteriskRed/>
                <br/><span className='fs-80'>(as displayed on meter either when LID is connected or when there is only meter installed)</span>
            </>,{labelWidth:4,fieldWidth:3, rowClasses:'mb-3'})}

            {form.val('lIDTelemetry') && form.renderYesNoOptionsRow('unitInDasCorrect',<>Confirm that flow units in DAS are correct? <AsteriskRed/></>,{labelWidth:4,fieldWidth:3,rowClasses:'mb-3'})}
            {form.val('lIDTelemetry') && form.val('unitInDasCorrect')===true && <>
                {form.renderTextBoxRow('dasCurrentReading',<>
                    Meter Reading in DAS at 7pm on Commissioning Date <AsteriskRed/>
                </>,{labelWidth:4,fieldWidth:3, rowClasses:'mb-3'})}
            </>}               

            {form.vals().newMeterEquipment == '5' &&  <div className={`row`}>
                <div className={`col-md-4 py-2`}>
                    Maintenance Notification Date
                    <br/><span className='fs-80'>(date as seen in DAS event list which triggered maintenance)</span>
                    <AsteriskRed/>
                </div>
                <div className={`col-md-3`}>
                    <DatePickerForForm form={form} fieldName="maintenanceNotificateDate" />
                </div>
            </div>}
        </>
    }
}